import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DevExContextMenuComponent } from '../../../devExtreme/src/devExContextMenu/devExContextMenu.component';
import { MatContextMenuComponent } from '../../../material/src/matContextMenu/matContextMenu.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { SubmenuDirection } from './abcContextMenu';

@Component({
    selector: 'abcContextMenu',
    template: `<ng-template #abcContextMenu></ng-template>`,
    standalone: false
})
export class AbcContextMenuComponent implements OnInit {
  @ViewChild('abcContextMenu', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  private _width: string | number;
  private eventListener = [];
  private componentRef;
  private _height: string | number;
  private _class: string;
  private _submenuDirection: SubmenuDirection;
  private _hoverStateEnabled: boolean;
  private _rtlEnabled: boolean;
  private _disabled: boolean;
  private _source: any;
  private _closeOnOutsideClick: boolean;
  private _style: ComponentStyle;
  @Input('id') id: string = 'id';
  @Input('target') target: string;
  @Input('dataSource') dataSource: any;
  @Input('style') chosenStyle: string;
  @Output() onItemClick = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input()
  get closeOnOutsideClick() {
    return this._closeOnOutsideClick;
  }
  set closeOnOutsideClick(data) {
    if (this.componentRef) {
      this.componentRef.closeOnOutsideClick = data;
    }
    this._closeOnOutsideClick = data;
  }
  @Input()
  get width() {
    return this._width;
  }
  set width(data: string | number) {
    this._width = data;
    if (this.componentRef) {
      this.componentRef.width = data;
      this.componentRef.refrech();
    }
  }
  @Input()
  get source() {
    return this._source;
  }
  set source(data: any) {
    this._source = data;
    if (this.componentRef) {
      this.componentRef.source = data;
    }
  }
  @Input()
  get height() {
    return this._height;
  }
  set height(data: string | number) {
    this._height = data;
    if (this.componentRef) {
      this.componentRef.height = data;
      this.componentRef.refrech();
    }
  }
  @Input()
  get style() {
    return this._style;
  }
  set style(data: ComponentStyle) {
    this._style = data;
    if (this.componentRef) {
      this.viewContainerRef.clear();
      this.createComponentInstance().subscribe((component) => {
        this.eventListener.forEach((element) => {
          component.addEventListener(element.type, element.listener);
        });
      });
    }
  }
  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }
  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }
  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }
  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }
  @Input()
  get submenuDirection() {
    return this._submenuDirection;
  }
  set submenuDirection(data) {
    if (this.componentRef) {
      this.componentRef.submenuDirection = data;
    }
    this._submenuDirection = data;
  }

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
  }

  ngOnInit() {
    this.createComponentInstance().subscribe((component) => {
      if (this.eventListener) {
        this.eventListener.forEach((element) => {
          component.addEventListener(element.type, element.listener);
        });
      }
    });
  }

  public createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          this.componentRef = this.abcComponentService.loadComponent(
            MatContextMenuComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.source = this.source;
          this.componentRef.style = this.style;
          break;
        }
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExContextMenuComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.source = this.source;
          this.componentRef.dataSource = this.dataSource;
          this.componentRef.id = this.id;
          this.componentRef.submenuDirection = this.submenuDirection ? this.componentRef.submenuDirection : 'auto';
          this.componentRef.closeOnOutsideClick = this.closeOnOutsideClick;
          this.componentRef.hoverStateEnabled = this.hoverStateEnabled;
          this.componentRef.disabled = this.disabled;
          this.componentRef.rtlEnabled = this.rtlEnabled;
          this.componentRef.style = this.style;
          this.componentRef.onItemClick.subscribe((event) => {
            this.itemClick(event.itemData.id);
          });
          break;
        }
      }
      this.componentRef.width = this.width;
      this.componentRef.height = this.height;
      this.componentRef.target = this.target;
      observer.next(this.componentRef);
    });
    return observable;
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    // I had to push events in an Array because this function is called before components are loaded for some reason
  }

  itemClick(event): void {
    this.onItemClick.emit(event);
  }

  hide() {
    this.componentRef?.hide();
  }
}
